import Child from './Child';

const DialogSwitchUserAccount = () => <Child />;

export default DialogSwitchUserAccount;
